// extracted by mini-css-extract-plugin
export var pageLink = "ContentfulBlockPageLink-module--pageLink--vlqgB";
export var text = "ContentfulBlockPageLink-module--text--d3PSa";
export var mainText = "ContentfulBlockPageLink-module--mainText--Ap2cu";
export var subText = "ContentfulBlockPageLink-module--subText--5Ctg+";
export var arrow = "ContentfulBlockPageLink-module--arrow--h5Pp7";